/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {z} from '@hono/zod-openapi';

import {automarketplEquipmentCatalogueRequestSchema} from './automarketplEquipmentCatalogueRequestSchema';
import {equipmentMappingTargetSchema} from './EquipmentMappingCoverageSchemas';

const equipmentMappingRuleBaseSchema = z.object({
  sourceIssueId: z.string().uuid().optional(),
  reason: z.string().trim().max(1000).default(''),
  vehicleContext: automarketplEquipmentCatalogueRequestSchema.nullish(),
});

export const equipmentMappingRuleRequestSchema = z
  .union([
    equipmentMappingRuleBaseSchema.extend({
      operation: z.literal('upsert_rule'),
      ruleId: z.string().uuid().optional(),
      operator: z.literal('ANY_OF'),
      sourceKeys: z.array(z.string().trim().min(1)).min(1),
      kind: z.literal('mapping'),
      targetTaxonomyType: z.string().min(1),
      targetExternalId: z.string().min(1),
    }),
    equipmentMappingRuleBaseSchema.extend({
      operation: z.literal('upsert_rule'),
      ruleId: z.string().uuid().optional(),
      operator: z.literal('ANY_OF'),
      sourceKeys: z.array(z.string().trim().min(1)).min(1),
      kind: z.literal('unsupported'),
      targetTaxonomyType: z.null(),
      targetExternalId: z.null(),
    }),
    equipmentMappingRuleBaseSchema.extend({
      operation: z.literal('disable_rule'),
      ruleId: z.string().uuid(),
    }),
  ])
  .openapi('EquipmentMappingRuleRequest');

export const equipmentMappingRemediationBatchSchema = z
  .object({
    sourceCoverageRunId: z.string().uuid().nullable(),
    pendingCount: z.number().int().nonnegative(),
    remediations: z.array(
      z.object({
        id: z.string().uuid(),
        sourceCoverageIssueId: z.string().uuid().nullable(),
        request: equipmentMappingRuleRequestSchema,
        reason: z.string(),
        createdBy: z.string(),
        createdAt: z.string().datetime(),
      })
    ),
  })
  .openapi('EquipmentMappingRemediationBatch');

export const equipmentMappingRuleSchema = z
  .object({
    id: z.string().uuid(),
    revisionId: z.string().uuid(),
    revision: z.number().int().positive(),
    operator: z.literal('ANY_OF'),
    sourceKeys: z.array(z.string()),
    kind: z.enum(['mapping', 'unsupported']),
    targetTaxonomyType: z.string().nullable(),
    targetExternalId: z.string().nullable(),
    vehicleContext: automarketplEquipmentCatalogueRequestSchema.nullish(),
    enabled: z.boolean(),
    reason: z.string(),
    createdBy: z.string(),
    createdAt: z.string().datetime(),
  })
  .openapi('EquipmentMappingRule');

export const equipmentCatalogueRecordSchema = z
  .object({
    key: z.string(),
    label: z.string().nullable(),
    vehicleType: z.string().nullable(),
    categoryKey: z.string().nullable(),
    categoryLabel: z.string().nullable(),
    parentKey: z.string().nullable(),
  })
  .openapi('EquipmentCatalogueRecord');

export const equipmentMappingRulesResponseSchema = z
  .object({
    observedCatalogue: z.boolean(),
    sourceCatalogue: z.array(equipmentCatalogueRecordSchema),
    taxonomy: z.array(
      equipmentMappingTargetSchema.extend({
        normalizedKey: z.string(),
      })
    ),
    rules: z.array(equipmentMappingRuleSchema),
  })
  .openapi('EquipmentMappingRulesResponse');
